module.exports = __webpack_public_path__ + "static/media/faqBackground.5719f2a6.jpg";